
/* eslint-disable max-len */

export default `
<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_3209_314)">
    <path d="M8.29289 11.293C8.68342 10.9025 9.31645 10.9025 9.70696 11.293C10.0974 11.6835 10.0974 12.3165 9.70696 12.707L4.70696 17.707C4.31644 18.0976 3.68342 18.0975 3.29289 17.707L0.292893 14.707C-0.0976311 14.3165 -0.0976311 13.6835 0.292893 13.293C0.683422 12.9025 1.31645 12.9025 1.70696 13.293L3.99992 15.5859L8.29289 11.293Z"/>
    <path d="M16.9999 16C17.5522 16 17.9999 16.4477 17.9999 17C17.9999 17.5523 17.5522 18 16.9999 18H10.9999C10.4476 18 9.99992 17.5523 9.99992 17C9.99992 16.4477 10.4476 16 10.9999 16H16.9999Z"/>
    <path d="M16.9999 12C17.5522 12 17.9999 12.4477 17.9999 13C17.9999 13.5523 17.5522 14 16.9999 14H13.9999C13.4476 14 12.9999 13.5523 12.9999 13C12.9999 12.4477 13.4476 12 13.9999 12H16.9999Z"/>
    <path d="M16.9999 8C17.5522 8 17.9999 8.44772 17.9999 9C17.9999 9.55228 17.5522 10 16.9999 10H2.99992C2.44764 10 1.99992 9.55228 1.99992 9C1.99992 8.44772 2.44764 8 2.99992 8H16.9999Z"/>
    <path d="M16.9999 4C17.5522 4 17.9999 4.44772 17.9999 5C17.9999 5.55228 17.5522 6 16.9999 6H2.99992C2.44764 6 1.99992 5.55228 1.99992 5C1.99992 4.44772 2.44764 4 2.99992 4H16.9999Z"/>
    <path d="M16.9999 0C17.5522 0 17.9999 0.447715 17.9999 1C17.9999 1.55228 17.5522 2 16.9999 2H2.99992C2.44764 2 1.99992 1.55228 1.99992 1C1.99992 0.447715 2.44764 0 2.99992 0H16.9999Z"/>
  </g>
  <defs>
    <clipPath id="clip0_3209_314">
      <rect width="18" height="18" fill="white"/>
    </clipPath>
  </defs>
</svg>
`
